export enum ClassTreeCommandType {
  MOVE = 'MOVE',
  DELETE = 'DELETE',
  RENAME = 'RENAME'
}
